export const UserLocale: any | string = ( new Intl.NumberFormat() ).resolvedOptions().locale;
export const searchContextSymbol = Symbol( 'search-context' );

/******************************* PRODUCTS ********************************/
export const  CheckPointTraderSlug: string = 'checkpoint-trader' as const;
export const  DarkMoneyIndicatorSlug: string = 'dark-money-indicator' as const;
export const  DeepMarketTraderSlug: string = 'deep-market-trader' as const;
export const  MonthlyTrendTraderSlug: string = 'monthly-trend-trader' as const;
export const  OptionsSoupSlug: string = 'options-soup' as const;
export const  ProfitSkimmerSlug: string = 'profit-skimmer' as const;
export const  SectorFocusSlug: string = 'sector-focus' as const;
export const  SectorProphetsSlug: string = 'sector-prophets' as const;
export const  TechnicalAnalysisMillionaireSlug: string = 'technical-analysis-millionaire' as const;
export const  MegaTrendProfitClubSlug: string = 'mega-trend-profit-club' as const;
export const  SmallCapCashCowsSlug: string = 'small-cap-cash-cows' as const;
export const  TrueSovereignProfitsSlug: string = 'true-sovereign-profits' as const;

/*********************** CONTENT MODEL "type" keys ***********************/
export const  Alerts: string = 'alerts' as const;
export const  Articles: string = 'articles' as const;
export const  BonusReports: string = 'bonus-reports' as const;
export const  Categories: string = 'categories' as const;
export const  Commentary: string = 'commentary' as const;
export const  Permissions: string = 'permissions' as const;
export const  Sectors: string = 'sectors' as const;
export const  SectorHistory: string = 'sector-history' as const;
export const  Tags: string = 'tags' as const;
export const  Tickers: string = 'tickers' as const;
export const  User: string = 'user' as const;
export const  Webinars: string = 'webinars' as const;

/**************************** GENERAL Constants **************************/
export const  MissingDataString: string = '---' as const;

/**************************** SECTOR Constants **************************/
export const  AllKey: string = 'all' as const;
export const  BullishPercentIndexKey: string = 'bpi' as const;
export const  PercentThirtyWeekKey: string = 'wk' as const;
export const  RelativeStrengthKey: string = 'rs' as const;

/****************************** Permissions Keys *****************************/
export const  TmiPublicContentPermissionKey: string = 'true-market-insiders' as const;
export const  TmiPublicContentNonHyphenated: string = 'true market insiders' as const;

export const  AllSectorBullishPercentIndexesPermissionKey: string = 'all-bpis' as const;
export const  ArticlesPermissionKey: string = 'articles' as const;
export const  BonusReportsPermissionKey: string = 'bonus-reports' as const;
export const  CoursePermissionsKey: string = 'courses' as const;
export const  EtfListingPermissionsKey: string = 'etf-listing' as const;
export const  MajorIndexBreadthPermissionsKey: string = 'major-index-breadth' as const;
export const  OptionsCalculatorPermissionKey: string = 'options-calculator' as const;
export const  PortfolioBuilderPermissionKey: string = 'position-key' as const;
export const  PositionSizeCalculatorPermissionKey: string = 'position-size-calculator' as const;
export const  ProductTradeAlertsPermissionKey: string = 'trade-alerts' as const;
export const  ProfilePermissionKey: string = 'profile' as const;
export const  RelativeStrengthMatrixPermissionKey: string = 'rs-matrix' as const;
export const  SectorAlertsPermissionKey: string = 'alerts' as const;
export const  SectorsPermissionKey: string = `${ Sectors }` as const;
export const  SpreadCalculatorsPermissionKey: string = 'spread-calculators' as const;
export const  StockPermissionsKey: string = 'stocks' as const;
export const  WebinarsPermissionsKey: string = 'webinars' as const;

/************************* ROUTE/ROUTER Constants ************************/

/*--------------------------- Public Page Path & Name Constants ---------------------------*/
export const  AboutUsName: string = `about-us` as const;
export const  AboutUsPath: string = `/${ AboutUsName }` as const;
export const  AboutVersionName: string = `about-version` as const;
export const  AboutVersionPath: string = `/${ AboutVersionName }` as const;
export const  ContactUsSlug: string = `contact-us` as const;
export const  ContactUsDisplayText: string = 'Contact Us' as const;
export const  ContactUsPath: string = `/${ ContactUsSlug }` as const;
export const  DashboardName: string = "dashboard" as const;
export const  DashboardPath: string = `/${ DashboardName }` as const;
export const  EmailConfirmationSlug: string = "email-verification-confirmation" as const;
export const  EmailConfirmationPath: string = `/${ EmailConfirmationSlug }` as const;

export const  ForbiddenName: string = `access-required` as const;
export const  ForbiddenPath: string = `/${ ForbiddenName }` as const;
export const  HomeName: string = `home` as const;
export const  HomePath: string = `/` as const;
export const  MediaSlug: string = 'media' as const;
export const  MediaPath: string = `/${ MediaSlug }` as const;
export const  NewPasswordName: string = `new-password` as const;
export const  NewPasswordPath: string = `/${ NewPasswordName }/:challengeid/:answer` as const;
export const  PrivacyPolicySlug: string = 'privacy-policy' as const;
export const  PrivacyPolicyPath: string = `/${ PrivacyPolicySlug }` as const;
export const  ProfileName: string = 'profile' as const;
export const  ProfilePath: string = `/${ ProfileName }` as const;
export const  RefundPolicySlug: string = 'refund-policy' as const;
export const  RefundPolicyPath: string = `/${ RefundPolicySlug }` as const;
export const  ResetPasswordName: string = `reset-password` as const;
export const  ResetPasswordPath: string = `/${ ResetPasswordName }` as const;
export const  SignInName: string = `sign-in` as const;
export const  SignInPath: string = `/${ SignInName }` as const;
export const  SignInAsUserName: string = `sign-in-as-a-user` as const;
export const  SignInAsUserPath: string = `${ SignInPath }/:token` as const;
export const  SignUpName: string = `sign-up` as const;
export const  SignUpPath: string = `/${ SignUpName }` as const;
export const  SmsTextPolicySlug: string = `sms-text-policy` as const;
export const  SmsTextPolicyPath: string = `/${ SmsTextPolicySlug }` as const;
export const  TermsOfUsePolicySlug: string = `terms-of-use` as const;
export const  TermsOfUsePolicyPath: string = `/${ TermsOfUsePolicySlug }` as const;
export const  WhitelistInstructionsSlug: string = `whitelist-instructions` as const;
export const  WhitelistInstructionsPath: string = `/${ WhitelistInstructionsSlug }` as const;

/*------------------------- Learning/Course Path & Name Constants -------------------------*/
export const  LearningName: string = `learning` as const;
export const  LearningPath: string = `/${ LearningName }` as const;
export const  ArticleSearchName: string = `articles` as const;
export const  ArticleSearchPath: string = `${ LearningPath }/${ ArticleSearchName }` as const;
export const  ArticleName: string = `article` as const;
export const  ArticlePath: string = `${ LearningPath }/${ ArticleSearchName }/:slug` as const;
export const  RelatedArticlesPath: string = `${ LearningPath }/${ Tags }/:slug` as const;
export const  TagPath: string = `${ LearningPath }/tags/:slug` as const;

export const  AuthorsName: string = `authors` as const;
export const  AuthorsPath: string = `${ LearningPath }/${ AuthorsName }` as const;
export const  AuthorBioName: string = `author` as const;
export const  AuthorBioPath: string = `${ AuthorsPath }/:slug` as const;
export const  CoursesName: string = `courses` as const;
export const  CoursesPath: string = `${ LearningPath }/${ CoursesName }` as const;
export const  CourseName: string = `course` as const;
export const  CourseSlugKey: string = `:courseSlug` as const;
export const  CoursePath: string = `${ CoursesPath }/${ CourseSlugKey }` as const;
export const  WebinarsName: string = `webinars` as const;
export const  WebinarSearchPath: string = `${ LearningPath }/${ WebinarsName }` as const;
export const  All: string = `all` as const;
export const  Completed: string = `completed` as const;
export const  Main: string = `main` as const;
export const  Upcoming: string = `upcoming` as const;
export const  WebinarAllAliasPath: string = `${ WebinarSearchPath }/${ All }` as const;
export const  WebinarCompletedAliasPath: string = `${ WebinarSearchPath }/${ Completed }` as const;
export const  WebinarMainAliasPath: string = `${ WebinarSearchPath }/${ Main }` as const;
export const  WebinarUpcomingAliasPath: string = `${ WebinarSearchPath }/${ Upcoming }` as const;
export const  WebinarName: string = `webinar` as const;
export const  WebinarPath: string = `${ LearningPath }/${ WebinarsName }/:slug` as const;

/*------------------------------ Tools Path & Name Constants ------------------------------*/
export const  NyseBpiName: string = 'bpi' as const;
export const  NyseBpiPath: string = `/${ NyseBpiName }` as const;

/*----------------------------- Product Path & Name Constants -----------------------------*/
export const  ProductsName: string = `products` as const;
export const  ProductsPath: string = `/${ ProductsName }/:productSlug` as const;
export const  ProductsAdvancedAliasName: string = 'products-advanced' as const;
export const  ProductsAdvancedAliasPath: string = `/${ ProductsAdvancedAliasName }/:productSlug` as const;

/*------------------------------ Alerts Path & Name Constants -----------------------------*/
export const  AlertsName: string = `alerts` as const;
export const  TradeAlertsName: string = `trade-alerts` as const;
export const  TradeAlertsPath: string = `/${ TradeAlertsName }` as const;
export const  TradeAlertName: string = `trade-alert` as const;
export const  TradeAlertPath: string = `${ TradeAlertsPath }/:slug` as const;
export const  LearningTradeAlertsAliasPath: string = `${ LearningPath }/${ AlertsName }` as const;
export const  LearningTradeAlertAliasPath: string = `${ LearningPath }/${ AlertsName }/:slug` as const;
export const  SectorAlertsName: string = `sector-alerts` as const;
export const  SectorAlertsPath: string = `/${ SectorAlertsName }` as const;
export const  AlertsAliasPath: string = `/${ Alerts }` as const;

/*------------------------------ Tools Path & Name Constants ------------------------------*/
export const  ToolsName: string = `tools` as const;
export const  ToolsPath: string = `/${ ToolsName }` as const;
export const  FavoritesSlug: string = `favorites` as const;
export const  AllSectorBPIsName: string = `all-bpis` as const;
export const  AllSectorBPIsPath: string = `${ ToolsPath }/${ AllSectorBPIsName }` as const;
export const  SectorBullishPercentIndicesName: string = `sector-bpis` as const;
export const  SectorBullishPercentIndicesPath: string = `${ ToolsPath }/${ SectorBullishPercentIndicesName }` as const;
export const  RelativeStrengthMatrixName: string = `rs-matrix` as const;
export const  RelativeStrengthMatrixPath: string = `${ ToolsPath }/${ RelativeStrengthMatrixName }` as const;
export const  MatrixHubRelativeStrengthPath: string = `${ ToolsPath }/matrix-hub${ RelativeStrengthMatrixPath }` as const;
export const  MajorIndexBreadthName: string = `major-index-breadth` as const;
export const  MajorIndexBreadthPath: string = `${ ToolsPath }/${ MajorIndexBreadthName }` as const;
export const  OptionsName: string = `options` as const;
export const  EtfListingName: string = `etf-listing` as const;
export const  EtfListingPath: string = `${ ToolsPath }/${ EtfListingName }` as const;
export const  SectorTreeSlug: string = `sector-tree` as const;
export const  SectorTreePath: string = `${ ToolsPath }/${ SectorTreeSlug }` as const;
export const  SectorsName: string = `${ Sectors }` as const;
export const  SectorsPath: string = `/${ Sectors }` as const;
export const  SectorDetailsName: string = `${ Sectors }-details` as const;
export const  SectorDetailsPath: string = `${ SectorsPath }/:sector` as const;
export const  SectorFavoritesName: string = `${ Sectors }-${ FavoritesSlug }` as const;
export const  SectorsFavoritesPath: string = `${ SectorsPath }/${ FavoritesSlug }` as const;
export const  EtfDetailsAliasPath: string = `/etfs/:ticker` as const;
export const  StockDetailsAliasPath: string = `/stocks/:ticker` as const;
export const  SecurityDetailsBasePath: string = `/securities` as const;
export const  SecurityDetailsPath: string = `${ SecurityDetailsBasePath }/:ticker` as const;
export const  SecurityOptionsPath: string = `/securities/:ticker/${ OptionsName }` as const;
export const  PortfoliosName: string = `portfolios` as const;
export const  PortfoliosPath: string = `${ ToolsPath }/${ PortfoliosName }` as const;
export const  PortfolioBuilderName: string = `portfolio-builder` as const;
export const  PortfolioBuilderPath: string = `${ ToolsPath }/${ PortfolioBuilderName }` as const;
export const  OptionsCalculatorName: string = `options-calculator` as const;
export const  OptionsCalculatorPath: string = `${ ToolsPath }/${ OptionsCalculatorName }` as const;
export const  PositionSizeCalculatorName: string = `position-size-calculator` as const;
export const  PositionSizeCalculatorPath: string = `${ ToolsPath }/${ PositionSizeCalculatorName }` as const;
export const  SpreadAnalyzerKey: string = `spread-analyzer` as const;
export const  SpreadCalculatorKey: string = `spread-calculators` as const;

/*------------------------- Profile Path & Name Constants -------------------------*/
export const  MyLibraryName: string = `my-library` as const;
export const  MyLibraryPath: string = `${ ProfilePath }/${ MyLibraryName }` as const;
export const  BonusReportsName: string = `bonus-reports` as const;
export const  BonusReportsSearchName: string = `bonus-reports-search` as const;
export const  BonusReportsPath: string = `${ MyLibraryPath }/${ BonusReportsName }` as const;
export const  BonusReportsSearchPath: string = `${ LearningPath }/${ BonusReportsName }` as const;
export const  BonusReportsForProductPath: string = `${ BonusReportsPath }?select-product=:productSlug` as const;
export const  MyArticlesPath: string = `${ MyLibraryPath }` as const;
export const  MyWebinarsName: string = `favorite-webinars` as const;
export const  MyWebinarsPath: string = `${ MyLibraryPath }/${ MyWebinarsName }` as const;

/*----------------------------------- Contentful category slug references -----------------------------------*/
export const  NyseBpiUpdateCategorySlug: string = `nyse-bpi-updates` as const;

/*------------------------------ Support Paths -----------------------------*/
export const  SupportName: string = `support` as const;
export const  SupportPath: string = `/${ SupportName }` as const;
export const  AppStatusName: string = `status` as const;
export const  AppStatusPath: string = `${ SupportPath }/${ AppStatusName }` as const;
export const  AppToolsName: string = `tools` as const;
export const  AppToolsPath: string = `${ SupportPath }/${ AppToolsName }` as const;

export const  FeatureNewsName: string = `features-news` as const;
export const  FeatureNewsPath: string = `/${ FeatureNewsName }` as const;

export const  ApplicationId: string = "bc8a907b-0e60-49a2-96ba-43a9b227c1d0" as const;